"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziRuleStatus = void 0;
var PonziRuleStatus;
(function (PonziRuleStatus) {
    PonziRuleStatus["NEW"] = "NEW";
    PonziRuleStatus["ACTIVE"] = "ACTIVE";
    PonziRuleStatus["INACTIVE"] = "INACTIVE";
})(PonziRuleStatus || (exports.PonziRuleStatus = PonziRuleStatus = {}));
//# sourceMappingURL=rule.js.map